import React from "react";
import playstoreIcon from "src/assets/images/not-data/playstore.png";
import appstoreIcon from "src/assets/images/not-data/app-store.png";

const ComingSoonModal = ({ clickedButton , handleClose }: { clickedButton: string , handleClose: () => void }) => {
  return (
    <>
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={handleClose}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg w-full max-w-xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-[#434343] hover:text-gray-700 text-2xl font-bold"
              onClick={handleClose}
            >
              &times;
            </button>
            <h2 className="font-size-35px font-Poppins-SemiBold text-center text-[#434343] mb-4">
              Coming Soon!
            </h2>
            <p className="text-center font-size-18px font-Poppins-Regular text-[#007A71] mb-4">
              We are excited to announce that our app will be available soon on: <br />
            </p>
            <div className="flex justify-center space-x-4 mb-4">
              {clickedButton === "playstore" && (
                <a
                  href="#"
                  className="hover:scale-105 transition-transform duration-200"
                >
                  <img
                    src={playstoreIcon}
                    alt="Play Store"
                    className="h-16"
                  />
                </a>
              )}
              {clickedButton === "appstore" && (
                <a
                  href="#"
                  className="hover:scale-105 transition-transform duration-200"
                >
                  <img
                    src={appstoreIcon}
                    alt="App Store"
                    className="h-16"
                  />
                </a>
              )}
            </div>
        </div>
      </div>
    </>
  );
};

export default ComingSoonModal;
